import { render, staticRenderFns } from "./second.vue?vue&type=template&id=03058c3a&scoped=true&"
import script from "./second.vue?vue&type=script&lang=js&"
export * from "./second.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03058c3a",
  null
  
)

export default component.exports